// 2024 Temporary Hit Points, saved by the server as `temporaryHitPoints` (`tempHealth` is current Hit Points).
export const temporaryHitPointsOf = (record) => Math.max(0, Math.floor(Number(record?.temporaryHitPoints) || 0));

/** An HP label with the creature's Temporary Hit Points, e.g. "18/30 +5". */
export const withTemporaryHitPoints = (display, record) => {
  const amount = temporaryHitPointsOf(record);
  return amount ? `${display} +${amount}` : display;
};
